export const OverlayBackground = () => (
    <div 
      className="fixed inset-0 z-10"
      style={{
        backgroundColor: '#FF722C',
        mixBlendMode: 'hue',
        pointerEvents: 'none'
      }}
    />
  );


  export const OverlayRD = () => (
    <div 
      className="fixed inset-0 z-10"
      style={{
        backgroundColor: '#FF722C',
        mixBlendMode: 'hue',
        pointerEvents: 'none'
      }}
    />
  );

// export default OverlayBackground